import { mapPostForView } from '../utils/map-post-for-view';
import { blogItemPageActions } from './blog-item-actions';

const initialState = {};

export const blogItemReducer = (state = initialState, action) => {
  switch (action.type) {
    case blogItemPageActions.blogItemFetched().type: {
      return {
        ...state,
        [action.payload.slug]: {
          isLoading: true,
          isError: false,
        },
      };
    }

    case blogItemPageActions.blogItemFulfilled().type: {
      return {
        ...state,
        [action.payload.slug]: {
          isError: false,
          isLoading: false,
          ...mapPostForView(action.payload),
        },
      };
    }

    case blogItemPageActions.blogItemRejected().type: {
      return {
        ...state,
        [action.payload.slug]: {
          isError: true,
          isLoading: false,
        },
      };
    }

    default:
      return state;
  }
};
